import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js";
import ParadigmaLabeledInput from "../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js";
import api from "../../../api";


class ModalEscalarTitularidad extends Component {
  constructor(props) {
    super(props);
    this.state = {
      id: null,
      venta: null,
      old_compradores_id: [],
      compradores_id: [],
      postVariables: ['compradores_id'],
      errors: [],
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func,
    id: PropTypes.func,
    action: PropTypes.oneOf(['EDIT',]).isRequired,
  }

  resetForm() {
    this.setState({
      id: null,
      venta: null,
      old_compradores_id: [],
      compradores_id: [],
      errors: {},
    });
  }

  getData() {
    const { postVariables } = this.state;
    let data = {...this.state.venta};
    postVariables.forEach(x => {
      data[x] = this.state[x];
    });
    data.loteo_id = data.loteo.id;
    data.lote_id = data.lote.id;
    return data;
  }

  setData(data) {
    this.setState({
      id: data.id,
      venta: data,
      old_compradores_id: data.compradores.map(c=>c.id),
      compradores_id: [],
    })
  }

  setErrors(errors) {
    this.setState({
      errors: errors,
    });
  }

  onChangeField(field, value) {
    this.setState(prevState => {
      let errors = prevState.errors;
      if (errors) errors[field] = null;
      prevState.errors = errors;
      prevState[field] = value;
      return prevState;
    });
  }

  getError(field) {
    let errors = this.state.errors;
    if (errors) return errors[field];
    else return null;
  }

  modalVars() {
    return {
      get: true,
      submitType: "PUT",
      title: "Escalar Titularidad",
      buttonTitle: "Escalar Titularidad",
      danger: false,
      buttonIcon: "fa fa-user-o fa-lg",
      successMessage: "El Escalado de Titularidad ha sido realizado con éxito.",
      saveButton: true,
      saveButtonLabel: "Confirmar",
      buttonClass: "",
      disabled: false,
      id: this.props.id,
    };
  }

  render() {
    let vars = this.modalVars();
    const fieldClassNames = ["ui-field-label-col", "ui-field-control-col"];
    return (
      <ParadigmaModal
        getUrl={api.servicios.escalartitularidad}
        submitUrl={api.servicios.escalartitularidad}
        submitType={vars.submitType}
        id={vars.id}

        onGotData={(data) => this.setData(data)}
        onGotErrors={(errors) => this.setErrors(errors)}
        onSubmit={(e) => this.props.onSubmit(e)}
        onClose={() => this.resetForm()}
        onPreSubmit={() => this.getData()}

        title={vars.title}

        danger={vars.danger}
        buttonClass={vars.buttonClass}

        successMessage={vars.successMessage}
        missingIdMessage={"Debe seleccionar una fila."}
        saveButtonLabel={vars.saveButtonLabel}
        buttonTitle={vars.buttonTitle}
        buttonIcon={vars.buttonIcon}
        saveButton={vars.saveButton}
        closeButton={true}
        className="ui-paradigma-modal ui-paradigma-modal-wide"
      >
        <section className="ui-modal-section">
          <p className="ui-section-label">Titularidad</p>
          <div className="ui-form-grid">
            <ParadigmaLabeledInput
              md={[12, 12]}
              classNames={fieldClassNames}
              label={"Titulares Actuales"}
              error={() => this.getError('old_compradores_id')}
              inputComponent={
                <ParadigmaAsyncSeeker
                  multiselect
                  clearable={false}
                  url={api.clientes.select}
                  parameters={{
                    paginationEnabled: false,
                    sort: ['apellido']
                  }}
                  disabled={true}
                  displayField="nombre_completo"
                  value={this.state.old_compradores_id ? this.state.old_compradores_id : []}
                />
              }
            />
            <ParadigmaLabeledInput
              md={[12, 12]}
              classNames={fieldClassNames}
              label={"Titulares Nuevos"}
              error={() => this.getError('compradores_id')}
              inputComponent={
                <ParadigmaAsyncSeeker
                  multiselect
                  clearable={false}
                  url={api.clientes.select}
                  parameters={{
                    paginationEnabled: false,
                    sort: ['apellido']
                  }}
                  displayField="nombre_completo"
                  value={this.state.compradores_id ? this.state.compradores_id : []}
                  onChange={data => {
                    this.onChangeField('compradores_id', (data) ? data.map(comp => comp.id) : []);
                  }}
                />
              }
            />
          </div>
        </section>
      </ParadigmaModal>
    );
  }
}

export default ModalEscalarTitularidad;



// WEBPACK FOOTER //
// ./src/views/Servicios/Servicios/ModalEscalarTitularidad.js